<template>
    <div>
      <!-- <h2 class="title">Account Information</h2> -->
      <p class="content">
        Before you can start using Truckl we need to create an account for you.
        <br/>

        All of the below fields are required.
      </p>
      <user-info :populated-email="accountInfo.accountEmailAddress" ref="form" v-model="userInfo" @isComplete="notify" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Snackbar } from 'buefy/dist/components/snackbar'

import UserInfo from '@/components/FormUserInformation'
export default {
  name: 'Registration-UserInfo',
  components: {
    UserInfo
  },

  props: {
    accountType: {
      default: 'shipper'
    }
  },

  data() {
    return {
      userInfo: {}
    }
  },

  async activated() {
    if (this.accountInfo.accountKey) {
      const isValid = await this.$refs['form'].validate()

      if (isValid) {
        this.notify(true)
      }
    }
  },

  computed: {
    ...mapGetters('user', { isUserLoggedIn: 'isLoggedIn', accountInfo: 'accountInfo' })
  },

  methods: {
    ...mapActions('registration', ['registerUser']),
    ...mapActions('user', { authenticate: 'authenticate', updateUserInfo: 'updateDetails' }),

    notify(isFormComplete) {
      this.$emit('canBeSubmitted', isFormComplete)
    },

    _showUserAlreadyExist() {
      Snackbar.open({
        message: `It looks like your email address is already registered with Truckl.
            Please click the "Cancel" button to go back to the log-in screen and try to log in with the password you created before or try resetting your password.
        `,
        position: 'is-top',
        type: 'is-danger',
        indefinite: true
      })
    },

    /**
     * Attempt to login (aka: get an auth token) using the current credential
     */
    async doLogin() {
      const userCreds = {
        username: this.userInfo.accountEmailAddress,
        password: this.userInfo.accountPassword
      }

      try {
        await this.authenticate(userCreds)
      } catch (error) {
        console.error(`Error trying to authenticate new user: `, error)
        this._showUserAlreadyExist()
        throw error
      }
    },

    /**
     * Actually register the user/account
     * @returns {Promise<void>}
     */
    async register() {
      const isValid = await this.$refs['form'].validate()

      if (!isValid) {
        this.notify(false)
        return
      }

      if (this.isUserLoggedIn) {
        const userInfo = Object.assign({}, this.accountInfo, this.userInfo)
        return this.updateUserInfo(userInfo)
      } else {
        try {
          await this.registerUser({ ...this.userInfo, accountType: this.accountType })
          console.log('Attempting to log user in')
          await this.doLogin()
        } catch (error) {
          console.error(`There was some type of error from the registration API: `, error)
          this._showUserAlreadyExist()
          throw error
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
